import React from "react";
import SignupForm from "../components/SignupForm";
import PageHeading from "../utils/PageHeading";
import useAppStore from "../store/useAppStore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";

import classes from "./Signup.module.css";
import { useNavigate } from "react-router";
export default function Signup() {
  const { userCreated, errorName } = useAppStore((state) => state);

  const navigate = useNavigate();
  useEffect(() => {
    useAppStore.setState({ errorName: null });
    userCreated && toast("Congrats you are Registerd");
    setTimeout(() => {
      userCreated && navigate("/");
      useAppStore.setState({ userCreated: false });
    }, 7000);
  }, [userCreated, navigate]);

  return (
    <div>
      <PageHeading>Signup</PageHeading>
      <ToastContainer />
      <div className={classes.signup}>
        <div>
          {errorName &&
            errorName.includes("duplicate") &&
            "This E-mail Adress Already Exists"}
        </div>
        <SignupForm />
      </div>
    </div>
  );
}
